/**
 * Avatar-Initialen-Chip (Brief §7): deterministische Pastellfarbe aus dem
 * Namen; Farbfamilien kommen aus den Status-/Primär-Tints (Token-Quelle).
 * K1 D9: fünf Familien ohne Gefahr-Rot (Verwechslungsgefahr mit Fehlern).
 */
export function AvatarChip({ name }: { name: string }) {
  const initials = name
    .split(/\s+/)
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
  let hash = 0;
  for (const ch of name) hash = (hash * 31 + ch.charCodeAt(0)) % 5;
  return (
    <span className={`wb-avatar-chip wb-avatar-${hash}`} aria-hidden>
      {initials}
    </span>
  );
}
